import {
  Pill,
  BrandPurple,
  color,
  GlitterGray,
  Lighter2,
  OnyxGray,
  radius,
  spaceToPx,
  Heading,
  Paragraph,
  styled,
} from 'canoe';

export const Header = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: ${spaceToPx('xl')}px;
`;

export const HeaderTitle = styled(Heading)`
  margin-bottom: 0;
`;

export const HeaderSubtitle = styled(Paragraph)`
  color: ${color(OnyxGray, Lighter2)};
  margin-bottom: 0;
`;

export const StyledImageBackground = styled.div`
  background-color: ${color(GlitterGray, Lighter2)};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: ${spaceToPx('s')}px solid ${color(GlitterGray, Lighter2)};
  border-radius: 8px;
  height: 291px;
  width: 494px;
`;

export const StyledContent = styled.div`
  flex: 1;
`;

export const StyledColumns = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const CreatorCard = styled.div`
  width: 275px;
  border: 1px solid ${color(BrandPurple)};
  border-radius: ${radius('regular')};
  padding: ${spaceToPx('xs')}px ${spaceToPx('s')}px ${spaceToPx('s')}px;
`;

export const CreatorDetails = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${spaceToPx('xs')}px;
`;

export const TagsContainer = styled.div`
  width: 275px;
  display: flex;
  flex-wrap: wrap;
  margin-top: ${spaceToPx('xl')}px;
`;

export const Tag = styled(Pill)`
  margin: 0 ${spaceToPx('s')}px ${spaceToPx('s')}px 0;
`;

export const CategoryPill = styled(Pill)`
  margin-top: ${spaceToPx('xs')}px;
`;
